import { useState } from "react";
import { useTranslation } from "react-i18next";

// ASSETS
import saveIcon from "../../assets/save_icon.png";
import closeIcon from "../../assets/close_icon.png";

// COMPONENTS
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import { createBankForBank } from "../../services/bank/banksForBank";
import ErrorBox from "../../components/ErrorBox";

const UpdateForeignBankModal = ({ onClose }) => {
  // HOOKS
  const { t } = useTranslation("general");
  const [isOpen, setIsOpen] = useState(false);

  // STATES
  const [loadingModal, setLoadingModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    address: "",
    phoneNumber: "",
  });

  const [errors, setErrors] = useState([]);

  // Handlers
  const validations = () => {
    const newErrors = []; // Local array to track errors

    if (!formData.name) {
      newErrors.push({ name: t("bankName") + " " + t("required") });
    }
    if (!formData.country) {
      newErrors.push({ country: t("country") + " " + t("required") });
    }
    if (!formData.address) {
      newErrors.push({ address: t("address") + " " + t("required") });
    }
    if (!formData.phoneNumber) {
      newErrors.push({ phoneNumber: t("phoneNumber") + " " + t("required") });
    }

    setErrors(newErrors);
    return newErrors.length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoadingModal(true);

    if (!validations()) {
      setLoadingModal(false);
      return;
    }

    try {
      const response = await createBankForBank(formData);

      if (response.status === 201) {
        onClose();
      }
    } catch (error) {
      console.error("Error creating foreign bank:", error);
    } finally {
      setLoadingModal(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => onClose()}
        title={t("addNewForeignBank")}
        footer={
          <>
            {loadingModal ? <Loader /> : null}
            <section className="edit-user-actions">
              <CustomButton
                onClick={handleSubmit}
                title={t("save")}
                icon={saveIcon}
                iconSize={16}
                disabled={loadingModal}
              />
              <CustomButton
                title={t("cancel")}
                variant="blank"
                icon={closeIcon}
                iconSize={14}
                onClick={() => onClose()}
              />
            </section>
          </>
        }
      >
        {errors.length > 0 && <ErrorBox>{t("emptyInputFields")}</ErrorBox>}
        <div>
          <label>{t("bankName")}:</label>
          <CustomInput
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            errorText={errors.find((err) => err.name)?.name}
          />
        </div>
        <div>
          <label>{t("country")}:</label>
          <CustomInput
            name="country"
            value={formData.country}
            onChange={handleInputChange}
            errorText={errors.find((err) => err.country)?.country}
          />
        </div>
        <div>
          <label>{t("address")}:</label>
          <CustomInput
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            errorText={errors.find((err) => err.address)?.address}
          />
        </div>
        <div>
          <label>{t("phoneNumber")}:</label>
          <CustomInput
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleInputChange}
            errorText={errors.find((err) => err.phoneNumber)?.phoneNumber}
          />
        </div>
      </Modal>
    </>
  );
};

export default UpdateForeignBankModal;
